import React, { Component } from "react";
import { auth } from "../../utils/auth";
import { apiUrl } from "../../utils/apiUrl";
import {
	toast,
	formatCurrency,
	getLink,
	getSuplidoresForDropdown,
	permisions,
} from "../../utils/helpers";
import Loader from "../general/Loader";
import Modal from "../general/Modal";
import Precios from "./Precios";
import { apiRequest } from "../../hooks/apiRequest";
import { ProductContext } from "./ProductContext";
import { crearUnidadConfig, desglosarEnEmpaques } from "../../utils/unidades";
import Select from "react-select";
import SelectAsync from "react-select/async";
import CreatableSelect from "react-select/creatable";
import { crearAlmacen, crearUbicacion, textoCrear } from "../../utils/almacenesUbicaciones";
import { postRequest } from "../../utils/request";
import CategoriasCheckboxTree from "../general/CategoriasCheckboxTree";
import { categoriasDeProducto, idsDeCategorias } from "../../utils/categorias";
import Seccion, { ErrorCampo } from "../general/Seccion";
import Presentaciones from "./Presentaciones";

class Edit extends Component {
	state = {
		errors: {},
		showDelete: false,
		precios_venta: [],
		unidades: this.props.unidades,
		unidad: { value: this.context.unidad, label: this.context.unidad },
		empaque: null,
		cantidadEmpaque: "",
		costoPor: "unidad",
		costo: this.context.costo,
        tipo: this.context.tipo,
        componentes: this.context.componentes || [],
		categorias: idsDeCategorias(categoriasDeProducto(this.context)),
		isLoading: false,
		firstTaxSelected: this.context?.impuesto || null,
		allowPriceChange: false,
		almacen: null,
		ubicacion: null,
		// Los creados aquí se suman a las listas que trae Layout.
		almacenesCreados: [],
		ubicacionesCreadas: [],
		creandoCatalogo: null,
	};
	elegirCatalogo = (catalogo, opcion) => {
		this.setState({ [catalogo]: opcion });
		this.props.handleInputChange(opcion?.value ?? "", `${catalogo}_id`);
	};
	crearOpcion = async (catalogo, nombre) => {
		this.setState({ creandoCatalogo: catalogo });
		const nueva =
			catalogo === "almacen" ? await crearAlmacen(nombre) : await crearUbicacion(nombre);
		this.setState({ creandoCatalogo: null });

		if (!nueva) return;

		const registro = { id: nueva.value, nombre: nueva.label };
		this.setState((state) =>
			catalogo === "almacen"
				? { almacenesCreados: [...state.almacenesCreados, registro] }
				: { ubicacionesCreadas: [...state.ubicacionesCreadas, registro] }
		);
		this.elegirCatalogo(catalogo, nueva);
	};

	componentDidMount() {
		this.initFormData();
		this.costoField = React.createRef();
	}
	initFormData = () => {
		if (
			Object.keys(this.context).length <= 0 ||
			!this.context?.precios_venta
		) {
			setTimeout(() => {
				this.initFormData();
			}, 500);
			return;
		}

		const precios = this.context?.precios_venta?.map((precio) => ({
			id: precio.id,
			precio_venta: parseFloat(precio.precio_venta),
			costo: parseFloat(precio.porciento_beneficio),
			impuesto: precio.impuesto_id,
			precio_total: parseFloat(precio.total),
			precio_paquete: precio.precio_paquete ?? null,
		}));

		const { unidad, unidad_id, unidad_empaque, unidad_empaque_id, cantidad_empaque } = this.context;

		this.setState({
			precios_venta: precios,
			unidad: { value: unidad, label: unidad, id: unidad_id },
			empaque: unidad_empaque
				? { value: unidad_empaque, label: unidad_empaque, id: unidad_empaque_id }
				: null,
			cantidadEmpaque: cantidad_empaque ?? "",
			almacen: this.context.almacen
				? { value: this.context.almacen.id, label: this.context.almacen.nombre }
				: null,
			ubicacion: this.context.ubicacion
				? { value: this.context.ubicacion.id, label: this.context.ubicacion.nombre }
				: null,
			unidades: this.props.unidades,
			categorias: idsDeCategorias(categoriasDeProducto(this.context)),
		});
	};
	onChangeCategorias = (ids) => {
		this.setState({ categorias: ids });
	};
	createUnidad = async (inputValue) => {
		this.setState({ isLoading: true });
		const nuevaUnidad = await crearUnidadConfig(inputValue);

		if (nuevaUnidad) {
			this.setState((state) => ({
				...state,
				unidad: nuevaUnidad,
				isLoading: false,
				unidades: [...state.unidades, nuevaUnidad],
			}));
		} else {
			this.setState({ isLoading: false });
		}
	};
	createEmpaque = async (inputValue) => {
		this.setState({ isLoading: true });
		const nuevaUnidad = await crearUnidadConfig(inputValue);

		if (nuevaUnidad) {
			this.setState((state) => ({
				empaque: nuevaUnidad,
				isLoading: false,
				unidades: [...state.unidades, nuevaUnidad],
			}));
		} else {
			this.setState({ isLoading: false });
		}
	};
	handleUnidadChange = (newValue) => {
		this.setState({ unidad: newValue });
		this.props.handleInputChange(newValue?.value, "unidad");
	};
	handleEmpaqueChange = (newValue) => {
		this.setState(
			newValue
				? { empaque: newValue }
				: { empaque: null, cantidadEmpaque: "", costoPor: "unidad" }
		);
	};
	editProducto = async (event) => {
		event.preventDefault();

		if (!auth.canEdit(permisions.editarProductos)) return;

		const data = new FormData(event.target);
		const response = await postRequest(apiUrl(`productos/${this.context.id}`), data);

		if (response.success) {
			this.props.history.push(getLink("/productos"));
		}

		if (response.code === 422) {
			this.setState({ errors: response.data.message });
		}
	};
	toggleDeleteModal = () => {
		this.setState({
			showDelete: !this.state.showDelete,
		});
	};
	deleteProducto = async (producto) => {
		const response = await postRequest(apiUrl(`productos/${producto}`), {}, 'delete');

		if (response.success) {
			this.props.history.push(getLink("/productos"));
			toast("Producto borrado.");
			return;
		} else {
			toast(response.data, "error");
		}
	};
	addPrecio = () => {
		this.setState((state) => ({
			precios_venta: [
				...state.precios_venta,
				{
					id: Date.now(),
					precio_venta: 0,
					impuesto: state.precios_venta.length > 0 ? state.precios_venta[0].impuesto : null,
					precio_total: 0,
					costo: 0,
				},
			],
		}));
	};
	removePrecio = async (producto) => {
		let res = await apiRequest(null, `precios/${producto}`, "delete");

		if (res.code === 201) {
			this.setState((state) => ({
				...state,
				precios_venta: state.precios_venta.filter(
					(precio) => precio.id !== producto
				),
			}));
		}
	};
	render() {
		const {
			errors,
			isLoading,
			unidades,
			unidad,
			empaque,
			cantidadEmpaque,
			firstTaxSelected,
			allowPriceChange,
			almacen,
			ubicacion,
			almacenesCreados,
			ubicacionesCreadas,
			creandoCatalogo,
		} = this.state;
		const { arbolGrupos = [], ubicaciones, almacenes, impuestos, handleInputChange, producto } =
			this.props;

		const notEditable = !auth.can(permisions.editarProductos);

		if (this.context === {}) {
			return <Loader />;
		}

		const costoProducto = this.costoField?.current?.value || producto.costo;
		const esProducto = this.context.tipo === "producto";

		// El empaque sólo cuenta cuando trae más de una unidad.
		const tieneEmpaque =
			this.context.tipo !== "grupo" && Boolean(empaque) && parseFloat(cantidadEmpaque) > 1;

		// El costo se muestra y se escribe en la unidad elegida; el producto
		// guarda (y los precios calculan sobre) el de su unidad base.
		const costoPor = tieneEmpaque ? this.state.costoPor : "unidad";
		const factorCosto = costoPor === "empaque" ? parseFloat(cantidadEmpaque) : 1;
		const etiquetaCosto = costoPor === "empaque" ? empaque.value : unidad?.value || "Und";
		const columnaCosto = tieneEmpaque ? "col-12 col-sm-4 col-md-3" : "col-12 col-sm-4";

		return (
			<div>
				<form
					method="post"
					onSubmit={this.editProducto}
					className="form-secciones"
				>
					<input type="hidden" name="_method" value="put" />
					<input
						type="hidden"
						name="producto_id"
						defaultValue={this.context?.id}
					/>
					<input
						type="hidden"
						name="tipo"
						defaultValue={this.context?.tipo}
					/>
					<div className="row">
						{/* COLUMNA PRINCIPAL */}
						<div className="col-lg-8">
							<Seccion
								titulo="Información general"
								icono="fas fa-info-circle"
								extra={
									this.context.tipo && (
										<span className="badge badge-secondary text-uppercase">
											{this.context.tipo}
										</span>
									)
								}
							>
								<div className="form-row">
									<div className="form-group col-12 col-md-6">
										<label className="label form-control-label">
											Nombre:
										</label>
										<input
											type="text"
											className="text-input form-control"
											id="nombre"
											name="nombre"
											disabled={notEditable}
											onChange={(e) =>
												handleInputChange(e.target.value, "nombre")
											}
											defaultValue={this.context?.nombre}
										/>
										<ErrorCampo errors={errors} campo="nombre" />
									</div>
									<div className="form-group col-12 col-md-6">
										<label className="label form-control-label">
											Referencia:
										</label>
										<input
											type="text"
											className="text-input form-control"
											id="referencia"
											name="referencia"
											disabled={notEditable}
											onChange={(e) =>
												handleInputChange(e.target.value, "referencia")
											}
											defaultValue={this.context.referencia}
										/>
										<ErrorCampo errors={errors} campo="referencia" />
									</div>
									<div className={`form-group col-12 ${esProducto ? "col-md-8" : ""}`}>
										<label className="label form-control-label">
											Descripción:
										</label>
										<input
											type="text"
											className="text-input form-control"
											id="descripcion"
											name="descripcion"
											disabled={notEditable}
											defaultValue={this.context.descripcion}
											onChange={(e) =>
												handleInputChange(e.target.value, "descripcion")
											}
										/>
										<ErrorCampo errors={errors} campo="descripcion" />
									</div>
									{esProducto && (
										<div className="form-group col-12 col-md-4">
											<label className="label form-control-label">
												Estado:
											</label>
											<select
												className="text-input form-control"
												id="estado"
												name="estado"
												disabled={notEditable}
												defaultValue={this.context.estado}
												onChange={(e) =>
													handleInputChange(e.target.value, "estado")
												}
											>
												<option value="">- Seleccionar -</option>
												<option value="nuevo">Nuevo</option>
												<option value="usado">Usado</option>
											</select>
											<ErrorCampo errors={errors} campo="estado" />
										</div>
									)}
								</div>
							</Seccion>

							<Seccion titulo="Presentaciones" icono="fas fa-box">
								<Presentaciones
									unidades={unidades || []}
									unidad={unidad}
									empaque={empaque}
									cantidadEmpaque={cantidadEmpaque}
									onChangeUnidad={this.handleUnidadChange}
									onChangeEmpaque={this.handleEmpaqueChange}
									onChangeCantidad={(valor) => this.setState({ cantidadEmpaque: valor })}
									onCreateUnidad={this.createUnidad}
									onCreateEmpaque={this.createEmpaque}
									isLoading={isLoading}
									disabled={notEditable}
									conEmpaque={this.context.tipo !== "grupo"}
									errors={errors}
								/>
							</Seccion>

							{this.state.tipo === "grupo" && (
								<Seccion titulo="Componentes" icono="fas fa-cubes">
									<div className="table-responsive">
										<table className="table mb-0">
											<thead>
												<tr>
													<th>Código</th>
													<th width="30%">Producto</th>
													<th className="text-center">Existencia Actual</th>
													<th className="text-center">Cantidad</th>
													<th className="text-right">Costo</th>
													<th>Nota</th>
												</tr>
											</thead>
											<tbody>
												{this.state?.componentes?.map((producto) => (
													<tr key={producto.id}>
														<td>{producto.componente.referencia}</td>
														<td>{producto.componente.nombre}</td>
														<td className="text-center">{producto.componente.cantidad}</td>
														<td className="text-center">{producto.cantidad}</td>
														<td className="text-right">{formatCurrency(producto.componente.costo)}</td>
														<td>{producto.nota}</td>
													</tr>
												))}
											</tbody>
										</table>
									</div>
								</Seccion>
							)}

							<Seccion titulo="Costo" icono="fas fa-coins">
								<div className="form-row">
									{tieneEmpaque && (
										<div className="form-group col-12 col-md-3">
											<label className="label form-control-label">
												Costo por:
											</label>
											<select
												className="form-control"
												value={costoPor}
												// Cambiar de unidad convierte lo mostrado; el costo base no cambia.
												onChange={(e) => this.setState({ costoPor: e.target.value, costoEscrito: null })}
											>
												<option value="unidad">{unidad?.value} (unidad)</option>
												<option value="empaque">
													{empaque.value} (x{cantidadEmpaque})
												</option>
											</select>
										</div>
									)}
									<div className={`form-group ${columnaCosto}`}>
										<label className="label form-control-label">
											Costo/{etiquetaCosto}:
										</label>
										{!allowPriceChange ? (
											<div
												className="form-control-plaintext d-flex align-items-center"
												onDoubleClick={() => this.setState({ allowPriceChange: true })}
											>
												{formatCurrency(this.context.costo * factorCosto)}
												{!notEditable && (
													<button
														type="button"
														className="btn btn-link p-0 ml-2"
														aria-label="Editar costo"
														onClick={() => this.setState({ allowPriceChange: true })}
													>
														<i className="fa fa-pen color-primary"></i>
													</button>
												)}
												<input
													type="hidden"
													name="costo"
													ref={this.costoField}
													value={this.context.costo || 0}
												/>
											</div>
										) : (
											<>
												{/* Se escribe en la unidad elegida; se guarda en base. */}
												<input
													type="number"
													inputMode="decimal"
													className="form-control"
													value={
														this.state.costoEscrito ??
														Math.round(parseFloat(producto.costo || 0) * factorCosto * 10000) / 10000
													}
													onChange={(e) => {
														const valor = e.target.value;
														this.setState({ costoEscrito: valor });
														handleInputChange(
															valor === "" ? "" : parseFloat(valor) / factorCosto,
															"costo"
														);
													}}
												/>
												<input
													type="hidden"
													name="costo"
													ref={this.costoField}
													value={producto.costo ?? 0}
												/>
											</>
										)}
										{factorCosto > 1 && (
											<small className="d-block text-muted">
												= {formatCurrency(parseFloat(costoProducto) || 0)} por {unidad?.value}
											</small>
										)}
									</div>
									<div className={`form-group ${columnaCosto}`}>
										<label className="label form-control-label">
											Impuesto:
										</label>
										{!allowPriceChange ? (
											<div className="form-control-plaintext">
												{this.context?.impuesto?.nombre}
											</div>
										) : (
											<Select
												id="impuesto_id"
												name="impuesto_id"
												menuPlacement="auto"
												defaultValue={
													this.context?.impuesto
														? impuestos.find(
																(impuesto) =>
																	impuesto.value === this.context?.impuesto?.id
														  )
														: null
												}
												onChange={(e) => handleInputChange(e, "impuesto")}
												options={impuestos}
											/>
										)}
									</div>
									<div className={`form-group ${columnaCosto}`}>
										<label className="label form-control-label">
											Costo total con impuesto:
										</label>
										<div className="form-control-plaintext">
											{formatCurrency(
												(parseFloat(costoProducto) +
													parseFloat(costoProducto) *
														this.context?.impuesto?.porcentaje) *
													factorCosto
											)}
										</div>
										<input
											type="hidden"
											name="costo_total"
											value={
												parseFloat(costoProducto) +
													parseFloat(costoProducto) *
														this.context?.impuesto?.porcentaje || 0
											}
										/>
									</div>
								</div>
								<ErrorCampo errors={errors} campo="costo" />
							</Seccion>

							<Seccion
								titulo="Precios de venta"
								icono="fas fa-tags"
								extra={
									<button
										type="button"
										onClick={() => this.addPrecio()}
										className="btn btn-link p-0"
									>
										<i className="fas fa-plus" /> Agregar precio
									</button>
								}
							>
								{this.state?.precios_venta?.map((precio, index) => (
									<Precios
										precio={precio}
										precios={this.state.precios_venta}
										index={index}
										key={index}
										costo={this.costoField}
										removePrecio={this.removePrecio}
										impuestos={impuestos}
										accion="editar"
										firstTaxSelected={firstTaxSelected}
										cantidadEmpaque={tieneEmpaque ? cantidadEmpaque : null}
										etiquetaUnidad={unidad?.value || "Und"}
										etiquetaEmpaque={empaque?.value}
									/>
								))}
								<ErrorCampo errors={errors} campo="precios" />
							</Seccion>
						</div>

						{/* COLUMNA LATERAL */}
						<div className="col-lg-4">
							<Seccion titulo="Inventario" icono="fas fa-warehouse">
								<div className="form-group">
									<label className="label form-control-label">
										En inventario:
									</label>
									<div className="form-control-plaintext">
										{this.context.inventariable ? (
											<>
												<strong>{this.context.cantidad}</strong> {this.context.unidad}
												{this.context.unidad_empaque && (
													<small className="d-block text-muted">
														= {desglosarEnEmpaques(this.context.cantidad, this.context)}
													</small>
												)}
											</>
										) : (
											<span>&infin;</span>
										)}
									</div>
								</div>
								{esProducto && (
									<>
										<div className="form-group">
											<label className="label form-control-label">
												Reorden:
											</label>
											<input
												type="number"
												name="reorden"
												min="0"
												inputMode="numeric"
												className="form-control"
												value={producto.reorden ?? ""}
												onChange={(e) =>
													handleInputChange(e.target.value, "reorden")
												}
											/>
											<ErrorCampo errors={errors} campo="reorden" />
										</div>
										<div className="form-group">
											<label className="label form-control-label" htmlFor="almacen_id">
												Almacén:
											</label>
											<input type="hidden" name="almacen_id" value={almacen?.value ?? ""} />
											<CreatableSelect
												inputId="almacen_id"
												options={[...almacenes, ...almacenesCreados].map((a) => ({
													value: a.id,
													label: a.nombre,
												}))}
												value={almacen}
												onChange={(opcion) => this.elegirCatalogo("almacen", opcion)}
												onCreateOption={(nombre) => this.crearOpcion("almacen", nombre)}
												formatCreateLabel={textoCrear}
												isClearable
												isLoading={creandoCatalogo === "almacen"}
												isDisabled={notEditable || creandoCatalogo === "almacen"}
												placeholder="- Seleccionar -"
												menuPlacement="auto"
											/>
											<ErrorCampo errors={errors} campo="almacen_id" />
										</div>
										<div className="form-group mb-0">
											<label className="label form-control-label" htmlFor="ubicacion_id">
												Ubicación:
											</label>
											<input type="hidden" name="ubicacion_id" value={ubicacion?.value ?? ""} />
											<CreatableSelect
												inputId="ubicacion_id"
												options={[...ubicaciones, ...ubicacionesCreadas].map((u) => ({
													value: u.id,
													label: u.nombre,
												}))}
												value={ubicacion}
												onChange={(opcion) => this.elegirCatalogo("ubicacion", opcion)}
												onCreateOption={(nombre) => this.crearOpcion("ubicacion", nombre)}
												formatCreateLabel={textoCrear}
												isClearable
												isLoading={creandoCatalogo === "ubicacion"}
												isDisabled={notEditable || creandoCatalogo === "ubicacion"}
												placeholder="- Seleccionar -"
												menuPlacement="auto"
											/>
											<ErrorCampo errors={errors} campo="ubicacion_id" />
										</div>
									</>
								)}
							</Seccion>

							<Seccion titulo="Clasificación" icono="fas fa-sitemap">
								{esProducto && (
									<div className="form-group">
										<label className="label form-control-label">
											Suplidor:
										</label>
										<SelectAsync
											name="contacto_id"
											cacheOptions
											defaultOptions
											isClearable
											menuPlacement="auto"
											loadOptions={(e) => getSuplidoresForDropdown(e)}
											defaultValue={{
												value: this.context?.suplidor?.id,
												label: this.context?.suplidor?.nombre,
											}}
										/>
										<ErrorCampo errors={errors} campo="contacto_id" />
									</div>
								)}
								{this.context.tipo && (
									<div className="form-group mb-0">
										<label className="label form-control-label">
											Categorías:
										</label>
										{/* La primera categoría queda como principal (`grupo`). */}
										<CategoriasCheckboxTree
											arbol={arbolGrupos}
											valor={this.state.categorias}
											onChange={this.onChangeCategorias}
											recargarArbol={this.props.recargarArbolGrupos}
											nombreCampo="categorias[]"
											emitirVacio
											disabled={notEditable}
										/>
										<ErrorCampo errors={errors} campo="categorias" />
									</div>
								)}
							</Seccion>
						</div>
					</div>

					{/* En móvil queda fija abajo y apilada, con la acción principal arriba. */}
					<div className="form-acciones">
						{!notEditable && (
							<button
								type="button"
								className="btn form-acciones__borrar"
								aria-label="Borrar producto"
								onClick={this.toggleDeleteModal}
							>
								<i className="fas fa-trash-alt"></i>
							</button>
						)}
						<button
							type="button"
							onClick={() =>
								this.props.history.push(getLink("/productos"))
							}
							className="btn btn-plain"
						>
							Cancelar
						</button>
						{!notEditable && (
							<button type="submit" className="btn btn-primary">
								Guardar
							</button>
						)}
					</div>
				</form>
				<Modal
					title="Borrar Producto"
					show={this.state.showDelete}
					callback={() => this.deleteProducto(this.context.id)}
					acceptText="Borrar"
					toggle={this.toggleDeleteModal}
				>
					¿Estás seguro de que deseas borrar este producto?
				</Modal>
			</div>
		);
	}
}
Edit.contextType = ProductContext;

export default Edit;
